import LeadModal from '../components/LeadModal';
import React, { useState } from 'react';
import { useSchool } from '../context/SchoolContext';
import { Link } from 'react-router-dom';
import { Plus, Search, MoreVertical, X, Upload, Pencil, FileDown, Eye } from 'lucide-react';
import ImportModal from '../components/ImportModal';
import './LeadManagement.css';

const LeadManagement = () => {
    const { leads = [], stagnantLeads = [], getPackageName, importLeads, loadMoreLeads, hasMoreLeads, totalLeads } = useSchool();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [leadToEdit, setLeadToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const handleEdit = (e, lead) => {
        e.preventDefault();
        e.stopPropagation();
        setLeadToEdit(lead);
        setIsModalOpen(true);
    };

    const filteredLeads = (leads || []).filter(lead =>
        String(lead.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(lead.phone || '').includes(searchTerm)
    );

    console.log('DEBUG: filteredLeads', filteredLeads);

    return (
        <div className="page-container">
            <div className="page-header">
                <div>
                    <h2 className="page-title">Lead Management</h2>
                    <p className="page-subtitle">Manage and track potential students</p>
                </div>
                <div className="flex gap-2">
                    <button
                        className="btn btn-secondary flex items-center gap-2"
                        onClick={() => setIsImportModalOpen(true)}
                    >
                        <Upload size={18} /> Import CSV
                    </button>
                    <button
                        className="btn btn-primary flex items-center gap-2"
                        onClick={() => { setLeadToEdit(null); setIsModalOpen(true); }}
                    >
                        <Plus size={18} /> Add New Lead
                    </button>
                </div>
            </div>

            {/* Filters */}
            <div className="filters-bar">
                <div className="search-input-wrapper">
                    <Search size={18} className="search-icon" />
                    <input
                        type="text"
                        placeholder="Search leads..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {/* Table */}
            <div className="table-container card">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Contact</th>
                            <th>Interest</th>
                            <th>Branch</th>
                            <th>Source</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLeads.length === 0 ? (
                            <tr><td colSpan="7" className="text-center py-8 text-secondary">No leads found.</td></tr>
                        ) : (
                            filteredLeads.map(lead => (
                                <tr key={lead.id}>
                                    <td className="font-medium">
                                        <Link to={`/leads/${lead.id}`} className="text-gold hover-underline flex items-center gap-2">
                                            {lead.name}
                                        </Link>
                                    </td>
                                    <td>
                                        <div className="contact-cell">
                                            <span>{lead.phone}</span>
                                            <span className="text-muted text-sm">{lead.email}</span>
                                        </div>
                                    </td>
                                    <td>{getPackageName ? getPackageName(typeof lead.interest === 'object' ? (lead.interest?.id || lead.interest?.name) : lead.interest) : (typeof lead.interest === 'object' ? '' : lead.interest)}</td>
                                    <td>{(lead.branch && typeof lead.branch === 'object') ? (lead.branch.branch_name || lead.branch.name || '') : (lead.branch || '')}</td>
                                    <td><span className="text-xs text-muted">{lead.source}</span></td>
                                    <td>
                                        <div className="flex flex-col gap-1">
                                            <span className={`status-badge ${(lead.status || '').toLowerCase()}`}>
                                                {lead.status}
                                            </span>
                                            {stagnantLeads.some(s => s.id === lead.id) && (
                                                <span className="status-badge stagnant text-center">
                                                    FOLLOW UP
                                                </span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="flex gap-1">
                                            <Link to={`/leads/${lead.id}`} className="icon-btn" title="View Details">
                                                <Eye size={16} />
                                            </Link>
                                            <button className="icon-btn" onClick={(e) => handleEdit(e, lead)} title="Edit">
                                                <Pencil size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                {hasMoreLeads && (
                    <div className="flex justify-center p-4 border-t border-slate-100">
                        <button className="btn btn-secondary" onClick={loadMoreLeads}>
                            Load More ({leads.length} of {totalLeads})
                        </button>
                    </div>
                )}
            </div>

            <LeadModal
                isOpen={isModalOpen}
                onClose={() => { setIsModalOpen(false); setLeadToEdit(null); }}
                leadToEdit={leadToEdit}
            />

            <ImportModal
                isOpen={isImportModalOpen}
                onClose={() => setIsImportModalOpen(false)}
                onImport={importLeads}
                title="Import Leads"
                templateHeaders={['Name', 'Phone', 'Email', 'Source', 'Branch', 'Interest']}
                sampleRow={['John Doe', '0771234567', 'john@example.com', 'Facebook', 'Harare', 'Full Package']}
            />
        </div>
    );
};

export default LeadManagement;
